const theme = {
  colors: {
    primaryOld: "hsl(195.5,88.8%,61.6%)",
    primary: "#69C7DD",
    primaryStrong: "#0080AD",
    primaryStrong2X: "#004576",
    white: "#FFFFFF",
    gray: "#BCC2C7",
    gray1: "#8F9498",
    grayBg: "#F0F0F4",
    black: "#000000",
    black1: "#3A3A3D",
    bg: "#F0F3F4",
    cardBoxShadow: "-2px 0px 10px 2px rgba(0, 0, 0, 0.61)",
    strongMarket: "#0080AD",
    strongMarketStroke: "#0080AD",
    strongMarketFill: "#0080AD",
    avgMarket: "#47BDF2",
    weakMarketFill: "#9BE4FF",
    weakMarketStroke: "#9BE4FF",
    error: "#FF1607",
  },
  timeOuts: {
    loadTime: 500,
  },
};

export default theme;
